var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0 15px" } },
    [
      !_vm.viewRecord.id
        ? _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _vm.planList.length && !_vm.loading
                ? _c(
                    "div",
                    {
                      ref: "scrollContainer",
                      staticClass: "scroll-container box-shadow-1",
                      on: { scroll: _vm.handleScroll },
                    },
                    _vm._l(_vm.planList, function (item, index) {
                      return _c(
                        "a-col",
                        {
                          key: index,
                          staticClass: "plan-card",
                          attrs: { span: 12 },
                        },
                        [
                          _c(
                            "a-card",
                            {
                              staticStyle: {
                                "border-radius": "5px",
                                padding: "0 10px",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "plan-card-content" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "title",
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                          _c(
                                            "a-tag",
                                            {
                                              attrs: {
                                                color:
                                                  item.rate > 0 ? "blue" : "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    item.rate > 0
                                                      ? "已完成"
                                                      : "待完成"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.status == 0,
                                                  expression:
                                                    "item.status == 0",
                                                },
                                              ],
                                              staticClass:
                                                "action-icon transparent-area-appear",
                                            },
                                            [
                                              _c("a-icon", {
                                                style: {
                                                  fontSize: "18px",
                                                  color: "#1783E8",
                                                  marginRight: "10px",
                                                },
                                                attrs: { type: "edit" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.editCard(item)
                                                  },
                                                },
                                              }),
                                              _c(
                                                "a-popconfirm",
                                                {
                                                  attrs: {
                                                    title: "是否删除该卡片？",
                                                  },
                                                  on: {
                                                    confirm: function ($event) {
                                                      return _vm.deleteCard(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("a-icon", {
                                                    style: {
                                                      fontSize: "18px",
                                                      color: "#FF4D4F",
                                                    },
                                                    attrs: { type: "delete" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return (() => {}).apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                活动日期:\n                "
                                          ),
                                          item.beginDate && item.endDate
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(item.beginDate) +
                                                    " 至 " +
                                                    _vm._s(item.endDate) +
                                                    "\n                "
                                                ),
                                              ])
                                            : _c("span", [_vm._v("无")]),
                                        ]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showPlanDetail(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                查看详情\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("a-progress", {
                                    attrs: {
                                      type: "circle",
                                      strokeColor: item.color,
                                      percent: item.rate,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "format",
                                          fn: function (percent) {
                                            return [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "24px",
                                                      "font-weight": "bold",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(percent) + "%"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "10px",
                                                    },
                                                  },
                                                  [_vm._v("完成进度")]
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c("EmptyData", {
                        attrs: { loading: _vm.loading, isSetPageCenter: true },
                      }),
                    ],
                    1
                  ),
            ],
            1
          )
        : [
            _c(_vm.componentList[_vm.type], {
              tag: "component",
              attrs: { viewRecord: _vm.viewRecord },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }